import { Component } from '@angular/core';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';
import { ServiceOfferingsComponent } from '../service-offerings/service-offerings.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { CompanyConfigService, CompanyConfig } from '../../services/company-config.service';

@Component({
  selector: 'app-services-page',
  templateUrl: './services-page.component.html',
  styleUrl: './services-page.component.css',
  imports: [MegamenuComponent, FooterComponent, ServiceOfferingsComponent, MatButtonModule, MatIconModule, MatCardModule, CommonModule]
})
export class ServicesPageComponent {
  config: CompanyConfig;

  constructor(private companyConfig: CompanyConfigService) {
    this.config = this.companyConfig.getConfig();
  }

  callPhone() {
    this.companyConfig.callPhone();
  }
  services = [
    {
      title: 'General Pest Control',
      description: 'Comprehensive protection against common household pests including ants, spiders, cockroaches, and more.',
      icon: 'pest_control',
      features: ['Monthly treatments', 'Interior & exterior protection', 'Guaranteed results']
    },
    {
      title: 'Termite Services',
      description: 'Complete termite inspection, treatment, and prevention services to protect your property investment.',
      icon: 'home_repair_service',
      features: ['Free inspections', 'Treatment options', 'Damage repair']
    },
    {
      title: 'Rodent Control',
      description: 'Effective mouse and rat control solutions with humane removal and prevention strategies.',
      icon: 'cruelty_free',
      features: ['Humane removal', 'Entry point sealing', 'Prevention plans']
    },
    {
      title: 'Bed Bug Treatment',
      description: 'Specialized bed bug elimination using the latest treatment methods and technologies.',
      icon: 'hotel',
      features: ['Heat treatments', 'Chemical options', 'Follow-up service']
    },
    {
      title: 'Mosquito Control',
      description: 'Seasonal mosquito control programs to help you enjoy your outdoor spaces.',
      icon: 'outdoor_grill',
      features: ['Yard treatments', 'Breeding site elimination', 'Seasonal programs']
    },
    {
      title: 'Commercial Services',
      description: 'Customized pest management solutions for businesses, restaurants, and commercial properties.',
      icon: 'business',
      features: ['Custom programs', 'Documentation', 'Emergency service']
    }
  ];
}